import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { Divider } from '@mui/material';

import { hasTrussDesignPermission } from '@paragon/login-tools';

import { useAppMonitor } from '../../../../monitor';
import { handleStandardSceneItemEditPropertiesAction } from '../../../../store/actions/sceneInteractionActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';
import { DeleteMenuItem } from '../shared-menu-items/DeleteMenuItem';

export function BearingMenu(props: { guid: string }) {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const canEditTrusses = useAppSelector(hasTrussDesignPermission);
  const componentDesign = useAppSelector(getActiveComponentDesign);
  if (componentDesign == null || !canEditTrusses) return null;

  const bearing = componentDesign.component.bearings.find((bearing) => bearing.guid === props.guid);
  if (bearing == null) return null;

  return (
    <SceneMenuContent>
      <SceneMenuItem
        text="Edit Properties"
        icon={<EditIcon />}
        onClick={async () => {
          await dispatch(handleStandardSceneItemEditPropertiesAction('bearing', bearing));
          monitor.recordInteraction('Bearing => Edit Properties menu item clicked');
        }}
      />

      <Divider />

      <DeleteMenuItem type="bearing" item={bearing} />
    </SceneMenuContent>
  );
}
